/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Kal_S0Inputs */

const en_tut_kal_s0 = /** @type {(inputs: Tut_Kal_S0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For any meeting, the **Unduh kalender (.ics)** button in the header produces a calendar file that any calendar app can open. This always works and needs no connected account.`)
};

const id_tut_kal_s0 = /** @type {(inputs: Tut_Kal_S0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk semua rapat, tombol **Unduh kalender (.ics)** di header menghasilkan berkas kalender yang bisa dibuka aplikasi kalender mana pun. Cara ini selalu tersedia dan tidak memerlukan koneksi ke akun mana pun.`)
};

/**
* | output |
* | --- |
* | "For any meeting, the **Unduh kalender (.ics)** button in the header produces a calendar file that any calendar app can open. This always works and needs no c..." |
*
* @param {Tut_Kal_S0Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_kal_s0 = /** @type {((inputs?: Tut_Kal_S0Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Kal_S0Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_kal_s0(inputs)
	return en_tut_kal_s0(inputs)
});